module.exports = "/assets/data/efabfc11d805cfb0843afe41f57db752-NE24.data.json";